import pushMsg from './pushMsg'

let instance
const plugin = {
  install(vue) {
    const Constructor = vue.extend(pushMsg)
    if (!instance) {
      instance = new Constructor()
      instance.$mount()
    }
    setTimeout(() => {
      document.querySelector('#app').appendChild(instance.$el)
    }, 50)
    vue.$pushMsg = instance
    vue.mixin({
      created: function() {
        this.$pushMsg = vue.$pushMsg
      }
    })
  }
}
export default plugin
export const install = plugin.install



// WEBPACK FOOTER //
// ./src/components/pushMsg/main.js